import { Toast } from "vant";

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

class PaymentStatus {
  static async getOrderInfo(store, orderId) {
    const res = await store.dispatch({
      type: "OrderInfo",
      orderId: orderId
    });

    if (!res || res.code !== 200 || !res.result) {
      return null;
    }

    return res.result.orderDetail || null;
  }

  static async waitPaid(store, orderId, options = {}) {
    const retryCount = options.retryCount || 10;
    const interval = options.interval || 1500;
    let lastOrder = null;

    Toast.loading({
      mask: false,
      forbidClick: true,
      message: "正在确认支付状态...",
      duration: 0
    });

    try {
      for (let i = 0; i < retryCount; i++) {
        lastOrder = await PaymentStatus.getOrderInfo(store, orderId);

        if (lastOrder && Number(lastOrder.payState) === 3) {
          Toast.clear();
          Toast.success("支付已确认");
          return {
            paid: true,
            orderInfo: lastOrder
          };
        }

        if (i < retryCount - 1) {
          await sleep(interval);
        }
      }
    } catch (e) {
      console.error("waitPaid failed:", e);
    }

    Toast.clear();
    Toast("支付结果处理中，请稍后刷新订单");
    return {
      paid: false,
      orderInfo: lastOrder
    };
  }
}

export default PaymentStatus;



// WEBPACK FOOTER //
// ./src/tools/paymentStatus.js